import Collapse from './Collapse';
export default Collapse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/collapse/index.js
// module id = 31
// module chunks = 0